module.exports = __webpack_public_path__ + "static/8-9b9a8ea24e58bf42da7f551c68a7eae6.jpg";